import Console from '@/shared/console';
import displayUtils from './display.utils';
import comparableUtils from './comparable.utils';
import pixEvaluateUtils from '@/services/common/pixEvaluate.utils.js';

export default {
  getComparablesList(comparables, mapCardsConfigs, { langCode, userDateFormat, fallbackText }) {
    mapCardsConfigs.forEach((cardConfig) => {
      displayUtils.groupItemsInTheSameGridSlot(cardConfig.config);
    });
    return comparables.map((comparable) => {
      return this.getComparableObject(comparable, mapCardsConfigs, { currentLang: langCode.toUpperCase(), userDateFormat, fallbackText });
    });
  },

  getComparableObject(comparable, mapCardsConfigs, params) {
    let uniqueId,
      isDual = false;
    const configToBeUsed = this.getConfigToBeUsed(mapCardsConfigs, comparable);

    const attributesList = [];

    //TODO decidir que hacer si no hay config
    if (!configToBeUsed) {
      Console.warn('There is no config that matches the condition');
      return null;
    }

    const isProperty = !!comparable.attributes && !comparable.features;

    if (isProperty) {
      uniqueId = comparable.RowId;
    } else {
      uniqueId = comparable.Id || comparable.id || comparable.SourceId;
    }

    configToBeUsed.forEach((cardConfig) => {
      const comparableObject = displayUtils.generateCommonObject(comparable, cardConfig, true, params);

      // todo this line should work here if (comparableObject && pixEvaluateUtils.evalConditions(cardConfig.Conditions, comparable, params.currentLang, null)) {
      if (comparableObject && pixEvaluateUtils.evalConditions(cardConfig.Conditions, comparable, 'EN', null)) {
        attributesList.push(comparableObject);
      }
    });

    const attributes = [];

    attributesList.forEach((attribute) => {
      if (!attribute.inSameRow) {
        attributes.push(attribute);
      } else {
        attributes[attributes.length - 1].values.push(attribute);
      }
    });

    let comparableBasket;
    if (comparable.ComparableStatus) {
      comparableBasket = comparable;
    }
    if (comparable.ParentInfo) {
      isDual = true;
    }

    return { ...comparable, attributes, uniqueId, isProperty, comparableBasket, isDual, comparableStatus: comparable.ComparableStatus, basketId: comparable.BasketId, documents: comparableUtils.getVisibleImages(comparable) ?? [] };
  },

  //recibe lista de comparables y retorna un array con los comparables ordenados para mostrar en 'comparable-list'

  getConfigToBeUsed(mapCardsConfigs, comp) {
    // Get the first mapCardConfig in which condition returns true with this comp
    const configuration = mapCardsConfigs.find((config) => config.condition(comp));
    if (configuration) {
      return configuration.config;
    } else {
      return undefined;
    }
  },
};
